<template>
    <div class="footer-links">
        <h3 class="footer-links__title mb-16">{{ title }}</h3>
        <ul class="footer-links__list">
            <li
                v-for="link in links"
                :key="link.name"
                v-tooltip="link.tooltip"
                class="footer-links__list-item"
            >
                <a
                    :href="link.url"
                    target="blank"
                    rel="noopener noreferrer"
                    class="footer-links__list-link"
                    @click="$emit('footer-link-redirect', $event, link)"
                >
                    <nuxt-img
                        :src="link.icon"
                        :alt="link.name"
                        loading="lazy"
                    />
                    <span v-if="link.label">
                        {{ link.label }}
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import {defineComponent} from 'vue';

import tooltip from '@/core/directives/tooltip';

export default defineComponent({
    name: 'FooterLinks',
    directives: {
        tooltip,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        links: {
            type: Array,
            default: () => ([]),
        },
    },
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common/footer/footer-links';
</style>
